const FACEBOOK_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID?.trim() || ""

type FbqArgs = [command: string, eventOrId: string, ...params: unknown[]]

type FbqFunction = {
  (...args: FbqArgs): void
  callMethod?: (...args: FbqArgs) => void
  queue?: FbqArgs[]
  loaded?: boolean
  version?: string
  push?: (...args: FbqArgs) => void
}

function getFbq(): FbqFunction | null {
  if (typeof window === "undefined") return null
  return (window as Window & { fbq?: FbqFunction }).fbq ?? null
}

export function hasFacebookPixel(): boolean {
  return Boolean(FACEBOOK_PIXEL_ID)
}

export function getFacebookPixelId(): string {
  return FACEBOOK_PIXEL_ID
}

export function trackFacebookEvent(eventName: string, params?: Record<string, unknown>): void {
  const fbq = getFbq()
  if (!fbq) return

  if (params) {
    fbq("track", eventName, params)
    return
  }

  fbq("track", eventName)
}
